import { currentChain, parentChain, clusterChains } from "lib/web3/chains";

const KNOWN_CHAINS = [
  currentChain,
  parentChain,
  ...(clusterChains ?? []),
].filter(Boolean);

export function getChainNameById(chainId: number) {
  return (
    KNOWN_CHAINS.find((chain) => chain.id === chainId)?.name || String(chainId)
  );
}

export function formatAuthorizationStatus(status: string | undefined) {
  if (!status) {
    return "-";
  }

  if (status.toLowerCase() === "ok") {
    return "OK";
  }

  const camel = status
    .toLowerCase()
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");

  return camel.replace(/([a-z])([A-Z])/g, "$1 $2");
}

export function formatValidityLabel(validity: boolean) {
  return validity ? "Valid" : "Invalid";
}
